export default () => {
  const fetchCustomer = () => homeFetch("customers/address?type=shipping", {});

  return {
    fetchCustomer,
  };
};
